import request from "@/utils/request";

export function saveCart (data){
  return request({
    url:'/osp/materialCart/saveOrUpdate',
    method:'post',
    data: data
  })
}

export function getCart (data){
  return request({
    url:'/osp/materialCart/list',
    method:'post',
    data: data
  })
}

export function removeByCode (data){
  return request({
    url:'/osp/materialCart/remove',
    method:'post',
    data: data
  })
}

